<template>
    <div class="wrap">
        <listHeader title="新增库存"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    v-decorator="['type', {required: true, rules: [{ message: '选择库存类型' }], initialValue: ''}]">>
                                    <a-select-option value="">选择库存类型</a-select-option>
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>


                            <a-form-item
                                label="数量"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写货物数量"
                                         v-decorator="['num', {rules: [{ required: true, validator: checkNumber,  message: '请填写货物数量' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="备注信息"
                                v-bind="formItemLayout"
                            >
                                <a-textarea
                                    v-decorator="['remark',{rules: [{ required: false, message: '请填写备注信息' }]} ]"
                                    placeholder="请填写备注信息"
                                    :auto-size="{ minRows: 3 }"
                                />
                            </a-form-item>

                            <a-form-item
                                label="图片"
                                v-bind="formItemLayout"
                            >
                                <a-upload
                                    name="avatar"
                                    list-type="picture-card"
                                    class="avatar-uploader"
                                    :show-upload-list="false"
                                    :customRequest="uploadImg"
                                >
                                    <div v-if="image">
                                        <img :src="image" alt="avatar"/>
                                    </div>
                                    <div v-else-if="image_str">
                                        <img :src="image_str" alt="avatar"/>
                                    </div>
                                    <div v-else>
                                        <a-icon :type="loading ? 'loading' : 'plus'"/>
                                        <div class="ant-upload-text">
                                            选择图片
                                        </div>
                                    </div>
                                </a-upload>
                                <p v-if="image" style="display: block; padding:0;font-size:14px;color:#1483cc">
                                    <a @click="reUpload">重新上传</a>
                                    <a @click="turnImg" style="padding-left:10px;">旋转照片</a>
                                </p>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import Common from '@/assets/js/common';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            visible: false, // 是否显示图片src
            loading: false, // 显示上传中
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'pid': '',
            },
            data: {},
            config: {},
            dateFormat: 'YYYY-MM-DD',
            turn: {
                image: '',
                turns: 0
            },
            image: '',
            image_str: '',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/psilog/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        url = '/manage/psilog/save';
                        values.pid = this.postData.pid;

                        if (this.image) {
                            values.image = this.image;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
        reUpload() {
            this.image = '';
        },
        turnImg() {
            // 初始化
            if (this.turn.image == '') {
                this.turn.image = new Image();
                this.turn.image.src = this.image;
            }
            this.image = Common.turnImg(this.turn);
        },
        uploadImg(e, maxsize=40, zoom=0.8, width=400, height=400) {
            this.visible = false;
            this.loading = true;

            let that = this;
            let zo = zoom;
            let reader = new FileReader();
            reader.readAsDataURL(e.file);

            reader.onload = function () {
                let size = this.result.length / 1024;
                let avatar = this.result;

                if (maxsize != 0 && size > maxsize) {

                    let image = new Image()
                    image.src = avatar;

                    new Promise(()=>{
                        image.onload = () => {
                            do {
                                avatar = Common.compressImg(image, zo, width, height);
                                zo -= 0.1;
                            } while (avatar.length / 1024 > maxsize && zo > 0.1)

                            that.image = avatar;
                        };
                    });
                } else {
                    that.image = avatar;
                }

                this.loading = false;
            };
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
